import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NotificationLayout } from '../../../shared/layout/notification-layout/notification-layout';
@Component({
  selector: 'app-sim-activated',
  imports: [RouterLink, NotificationLayout],
  templateUrl: './sim-activated.html',
  styleUrl: './sim-activated.scss',
})
export class SimActivated {}
